import { Component, OnInit } from '@angular/core';
import { tenantConfig} from 'src/app/Utils/general';
@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {

  tenantData = tenantConfig

  constructor() { }

  ngOnInit(): void {
  }

}
